<template>
    <div :class="'toast ' + type">
        <div class="message-container">
            <DIcon :class="iconColor" :name="iconName" class="icon" />
            <div class="copy-m bold">
                {{ bodyText }}
            </div>
            <DIcon name="x" class="x-icon" :class="iconColor" @click="$emit('removeToast', toast)" />
        </div>

        <Button v-if="buttonText" :value="buttonText" size="small" type="secondary" @click="$emit('click')" />
    </div>
</template>

<script>
import Button from '@/components/Button'
import DIcon from '@/components/FeatherIcon'

export default {
    name: 'Toast',
    components: {
        DIcon,
        Button,
    },
    props: {
        toast: {
            type: Object,
            required: false,
        },
        type: {
            type: String,
            note: 'the type of the toast',
            default: 'default',
            required: false,
        },
        bodyText: {
            type: String,
            note: 'the body text which is displayed on the toast',
            required: true,
        },
        buttonText: {
            type: String,
            note: 'the text that should be displayed on the button',
            required: false,
            default: null,
        },
    },
    computed: {
        iconName() {
            switch (this.type.toLowerCase()) {
                case 'default':
                case 'success':
                    return 'smile'
                case 'warn':
                    return 'alert-triangle'
                case 'error':
                    return 'alert-circle'
            }
            return ''
        },
        iconColor() {
            switch (this.type.toLowerCase()) {
                case 'default':
                    return 'dark'
                case 'success':
                    return 'white'
                case 'warn':
                    return 'white'
                case 'error':
                    return 'white'
            }
            return ''
        },
    },
}
</script>

<style lang="sass" scoped>
.toast
  background: $neutral-white
  padding: $s $m $s $s
  border-radius: 10px
  min-width: 240px
  display: flex
  justify-content: space-between
  align-items: center

  .x-icon
    margin-left: $s
    cursor: pointer

  .message-container
    display: flex
    align-items: center

    &::v-deep .feather-icon
      &.white
        svg
          stroke: white

  .icon
    margin-right: $s

  .copy-m
    color: $neutral-black

  &.default
    border: 1px solid $neutral-3

  &.warn
    background-color: $yellow

    .copy-m
      color: $neutral-white

  &.error
    background-color: $red

    .copy-m
      color: $neutral-white

  &.success
    background-color: $green

    .copy-m
      color: $neutral-white
</style>
